import * as requestFromServer from "./organizationCategoryCrud";
import {
  superAdminOrganizationCategorySlice,
  callTypes
} from "./organizationCategorySlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminOrganizationCategorySlice;

export const fetchOrganizationCategorys = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrganizationCategory(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.organizationCategorysFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchOrganizationCategoryById = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrganizationCategoryById(id)
    .then(response => {
      const { data } = response.data;
      dispatch(actions.organizationCategoryFetched({ data }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createOrganizationCategory = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createOrganizationCategory(payload)
    .then(response => {
      dispatch(actions.organizationCategoryReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

export const updateOrganizationCategory = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateOrganizationCategory(payload)
    .then(response => {
      dispatch(actions.organizationCategoryReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

// export const deleteOrganizationCategoryFolder = id => dispatch => {
//   dispatch(actions.startCall({ callType: callTypes.action }));
//   return requestFromServer
//     .deleteOrganizationCategoryFolder(id)
//     .then(response => {
//       dispatch(actions.organizationCategoryReload);
//       return response;
//     })
//     .catch(error => {
//       if (error.response.status === 401) {
//         toast.error(error.response.data.message, toastOption);
//         dispatch(auth.logout());
//       }
//       // dispatch(actions.catchError({ error, callType: callTypes.list }));
//       dispatch(actions.catchError());
//       return error.response;
//     });
// };
